import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { SEND_NOTIFICATION } from '../actions';

export const sendNotificationEpic = (action$, store, { api }) =>
    action$.ofType(SEND_NOTIFICATION).mergeMap(action =>
        Observable.from(api.sendNotification(action.payload))
            .map(response => actions.sendNotificationSuccess(response.data))
            .catch(error => Observable.of(actions.sendNotificationFailure(error))),
    );
